import { useQuery } from "urql";

const DASHBOARD = `
query landing_data($companyId:String!){
    Landing(companyId:$companyId){
    id,
    receivable,
    toPay,
    bankAcountAmount,
    bankCreditAmount,
    last12MonthSales{
      month,
      sales,
      label
    },
    expiredVsValidSales{
      expired,
      valid
    },
    paimentColectionTable{
    rut,
    name,
    valid,
    expired30,
    expired60,
    expired90,
    expiredOlder,
    },
    lastBankUpdate
  }
}
`;

export const GetDashboarData = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: DASHBOARD,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_SII_SALES = `
  query GET_SII_SALES_12_MONTHS($companyId: String!) {
    get12MonthsNetSales(companyId: $companyId){
      month
      label
      sales
    }
  }
`;

export const GetSII12MonthsSales = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_SII_SALES,
    variables: { companyId },
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_LAST_SII_SALES = `
  query GET_SII_SALES_LAST_12_MONTHS($companyId: String!) {
    getLast12MonthsNetSales(companyId: $companyId){
      month
      label
      sales
    }
  }
`;

export const GetSIILast12MonthsSales = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_LAST_SII_SALES,
    variables: { companyId },
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}




const GET_SII_PURCHASES = `
  query GET_SII_PURCHASES_12_MONTHS($companyId: String!) {
    get12MonthsNetPurchases(companyId: $companyId){
      month
      label
      sales
    }
  }
`;

export const GetSII12MonthsPurchases = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_SII_PURCHASES,
    variables: { companyId },
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_LAST_SII_PURCHASES = `
  query GET_SII_PURCHASES_LAST_12_MONTHS($companyId: String!) {
    getLast12MonthsNetPurchases(companyId: $companyId){
      month
      label
      sales
    }
  }
`;

export const GetSIILast12MonthsPurchases = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_LAST_SII_PURCHASES,
    variables: { companyId },
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}













const GET_DASHBOARD_CARDS = `
  query GET_DASHBOARD_CARDS($companyId: String!) {
    dashboardCards(companyId: $companyId){
      bankAcountAmount
      bankCreditAmount
      toPay
      toReceive
    }
  }
`;

export const GetDashboardCards = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_DASHBOARD_CARDS,
    variables: { companyId },
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const GET_PENDING_PAYMENTS = `
  query GET_PENDING_PAYMENTS($companyId: String!) {
    findPaymentCollection(companyId: $companyId){
      rut
      name
      valid
      expired30
      expired60
      expired90
      expiredOlder
      documents
    }
  }
`;

export const GetPendingPaymentDashboard = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_PENDING_PAYMENTS,
    variables: { companyId },
  })

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
}

const PAYABLERECEIVABLESUMMARY = `
query payable_summary($companyId:String!, $isPayable:Boolean!){
  getPayableReceivableSummary(companyId:$companyId, isPayable:$isPayable){
    valid{
      documentType,
      amount,
      summary
    },
    expired30{
      documentType,
      amount,
      summary
    },
    expired60{
      documentType,
      amount,
      summary
    },
    expired90{
      documentType,
      amount,
      summary
    },
    expiredOlder{
      documentType,
      amount,
      summary
    }
  }
}
`;

export const GetPayableReceivableSummary = (companyId, isPayable) => {
  const [result, reexecuteQuery] = useQuery({
    query: PAYABLERECEIVABLESUMMARY,
    variables: { companyId, isPayable }
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const TOTALINVOICES = `
query INVOICES_TOTAL($companyId: String!){
  getTotalInvoice(companyId: $companyId){
    amount
  }
}`;

export const GetTotalInvoices = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: TOTALINVOICES,
    variables: { companyId }
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const TOTAL_CHECKS = `
query TOTAL_CHECKS($companyId: String!, $isReceived: Boolean!){
  getTotalChecks(companyId: $companyId, isReceived: $isReceived){
    amount
  }
}`;

export const GetChecks = (companyId, isReceived) => {
  const [result, reexecuteQuery] = useQuery({
    query: TOTAL_CHECKS,
    variables: { companyId, isReceived }
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const GET_OTHER_INCOME = `
query GET_OTHER_INCOME($companyId: String!){
  getOtherIncome(companyId: $companyId){
    amount
  }
}`;

export const GetTotalOtherIncome = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_OTHER_INCOME,
    variables: { companyId }
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const COMPANYLIST = `
query COMPANIES_BY_USER {
  companiesByUser {
    id
    users {
      userId
      role
    }
    name
    rut
    plan
    providerPaymentDays
    clientPaymentDays
    trialExpirationDate
    suscriptionId
    alias
    __typename
  }
}
`;

export const GetCompanyList = () => {
  const [result, reexecuteQuery] = useQuery({
    query: COMPANYLIST,
    variables: {},
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};
const LINEDASHBOARD = `
query CashflowQuery($companyId: String!, $currencyType: SupportedCurrency) {
  Cashflow(companyId: $companyId, currencyType: $currencyType) {
    companyId
    monthSerie {
      totalIncome
      outflows
      closingBalance
      startDate
    }
    daySerie {
      totalIncome
      outflows
      closingBalance
      startDate
    }
    weekSerie {
      totalIncome
      outflows
      closingBalance
      startDate
    }
  }
}`;

export const GetLineDashboarData = (companyId, currencyType) => {
  const [lineResult, reExecuteQuery] = useQuery({
    query: LINEDASHBOARD,
    variables: { companyId, currencyType },
  });
  const { data, fetching, error } = lineResult;
  return { data, fetching, error, reExecuteQuery };
};

const CONCILIATION_RATIO = `
query ratio ($companyId:String!,$month: DateTime!){
  getMonthlyMatchsRatio(companyId:$companyId,month:$month)
}`;

export const GetConciliationRatio = (companyId, month) => {
  const [result, reExecuteQuery] = useQuery({
    query: CONCILIATION_RATIO,
    variables: { companyId, month },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reExecuteQuery };
};

const CASHFLOW = `
query CashflowQuery($companyId: String!, $currencyType: SupportedCurrency) {
  Cashflow(companyId: $companyId, currencyType: $currencyType) {
    startDate
    endDate
    companyId
    monthObject {
      delayedAreas
      columns {
        label
        endDate
        startDate
      }
      cashflowObjectsTransposed
      salesProjectionWarn
    }
    weekObject {
      delayedAreas
      columns {
        label
        endDate
        startDate
      }
      cashflowObjectsTransposed
      salesProjectionWarn
    }
    dayObject {
      delayedAreas
      columns {
        label
        endDate
        startDate
      }
      cashflowObjectsTransposed
      salesProjectionWarn
    }
  }
  PastCashflow(companyId: $companyId, currencyType: $currencyType) {
    startDate
    endDate
    companyId
    monthObject {
      delayedAreas
      columns {
        label
        endDate
        startDate
      }
      cashflowObjectsTransposed
      
    }
    weekObject {
      delayedAreas
      columns {
        label
        endDate
        startDate
      }
      cashflowObjectsTransposed
    }
    dayObject {
      delayedAreas
      columns {
        label
        endDate
        startDate
      }
      cashflowObjectsTransposed
    }
  }
}`;

export const GetCashflow = (companyId, currencyType) => {
  const [lineResult, reExecuteQuery] = useQuery({
    query: CASHFLOW,
    variables: { companyId, currencyType },
  });
  const { data, fetching, error } = lineResult;
  return { data, fetching, error, reExecuteQuery };
};

const GET_FLOW_STRUCTURE = `query GetFlowStructure($companyId: String!) {
  getFlowStructure(companyId: $companyId){
    report {
      INCOME {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        isTotal
        isDefault
        isVisible
        fields {
          label
          cashflowAreaId
          isIncome
          isVisible
          isDefault
          isHidden
        }
        values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          isClickable
          documents
        }
      }
      
      EXPENSE {
        label
        cashflowCategoryId
        oldCategoryKey
        isIncome
        isTotal
        isDefault
        isVisible
        fields {
          label
          cashflowAreaId
          isIncome
          isVisible
          isDefault
          isHidden
        }
        values {
          fieldValue
          start
          end
          currency
          flowView
          isLate
          isProjected
          isPast
          isTotal
          isClickable
          documents
        }
      }
    }
    weekValues {
      start
      end
      startAmount
      endAmount
      variationAmount
      primaryView
    }
    monthValues {
      start
      end
      startAmount
      endAmount
      variationAmount
      primaryView
    }
    dayValues {
      start
      end
      startAmount
      endAmount
      variationAmount
      primaryView
    }
    updatedAt
  }
}`

export const GetFlowStructure = (companyId) => {
  const [flowResult, reExecuteQuery] = useQuery({
    query: GET_FLOW_STRUCTURE,
    variables: { companyId },
  });
  const { data, fetching, error } = flowResult;
  return { data, fetching, error, reExecuteQuery };
};

const GET_HISTORICAL_MONTHLY_RECONCILIATIONS = `
  query getHistoricalMonthlyReconciliations($companyId: String!) {
      getHistoricalMonthlyReconciliations(companyId: $companyId){
          banks{
              accountNumber
              bankId
              currency
              receivedTransactionsCount
              receivedTransactionsTotal
              reconciledTransactionsCount
              spendTransactionsCount
              spendTransactionsTotal
              transactionsCount
              transactionsTotalAmount
          }
          currenciesSummary{
              currency
              receivedTransactionsTotal
              reconciledTransactionsCount
              spendTransactionsTotal
              transactionsCount
          }
          period
          reconciledTransactionsCount
          transactionsCount
      }
  }
`;

export const GetHistoricalMonthlyReconciliations = (variables) => {
  const [result, reExecuteQuery] = useQuery({
    query: GET_HISTORICAL_MONTHLY_RECONCILIATIONS,
    variables,
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reExecuteQuery };
};